// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1PfxJ","head":"ProcedureTableInfo_head__2RI6B"};